import { ApplicationTypes, CornerCountersinkHoles, attachComponent, featureLabels } from 'metalworks-domain'

import { detailComponent, entityHeaderComponent, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton, ReplaceEntityDropdown } from '@salsita-ai/platform-project-sdk/react'

import { CountersinkHolePropertyPage } from '../ui/property-pages/CountersinkHolePropertyPage'

export const cornerCountersinkHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('CornerCountersinkHoles')
    .attach(self => {
      return {
        title: featureLabels[CornerCountersinkHoles.type],
        subtitle:
          self.topRadius > 0
            ? `Ø\u00a0${self.topRadius * 2}mm, 90°\u00a0countersink, Ø\u00a0${self.bottomRadius * 2}mm through`
            : `There's no countersink hole type available for currently selected plate.`,
        description: 'Countersink holes for all corners of the plate.',
        thumbnailUrl: '/thumbnails/countersink-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('CornerCountersinkHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <CountersinkHolePropertyPage id={s.id} disableAnchorSwitching />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('CornerCountersinkHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      // TODO: this now needs separate replace entity component
      primaryButton: <ReplaceEntityDropdown entityId={s.id} />,
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
]
